<template>
    <div>
        <!-- <img class="bg-img" src="@/assets/v2/login.jpg"> -->
        <div class="bg-wrapper">
            <div class="register">
                <van-nav-bar class="nav-bar">
                    <template #left>
                        <van-icon name="arrow-left" color="#1989fa" @click="back()" />
                    </template>
                    <template #right>
                        <div style="background: #1989fa; border-radius: 50%;" @click="switchLanguage">
                            <img src="@/assets/v2/changeLang.png" style="width: 32px; display: block;">
                        </div>
                    </template>
                </van-nav-bar>
                <div class="wrapper">
                    <!-- <div class="logo-container">
                        <div class="logo-wrapper">
                            <img
                                class="logo-img"
                                :src="this.$store.getters.getBaseInfo.ico !== undefined ? 'https://houtai.fcwr1.com' + this.$store.getters.getBaseInfo.ico:''"
                            >
                        </div>
                    </div> -->
                    <van-image width="100%" v-if="$i18n.locale == 'ja'"
                        :src="config.baseURL + $store.getters.getBaseInfo.ico" fit="cover"></van-image>
                    <van-image width="100%" v-else-if="$i18n.locale == 'ko'"
                        :src="config.baseURL + $store.getters.getBaseInfo.ko_ico" fit="cover"></van-image>
                    <van-image width="100%" v-else :src="config.baseURL + $store.getters.getBaseInfo.en_ico"
                        fit="cover"></van-image>
                    <div class="title">{{ $t('register') }}</div>
                    <div class="loginForm">
                        <van-field v-model="username" clearable input-align="left" class="input"
                            :placeholder="$t('userNamePlaceholder')" />
                        <van-field v-model="password" :type="passwordType" input-align="left" class="input"
                            :placeholder="$t('passwordPlaceholder')">
                            <template slot="right-icon">
                                <van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                                    @click="switchPasswordType" />
                            </template>
                        </van-field>
                        <van-field v-model="code" clearable input-align="left" class="input"
                            :placeholder="$t('inviteCodeePlaceholder')" />
                        <!-- <div class="agreement">
                            <van-checkbox v-model="checked" checked-color="#6529c9" />
                            <span class="agreement-text">{{ $t('consentAgreement') }}</span>
                        </div> -->
                        <van-button class="login-btn" type="primary" size="normal" @click="doRegister()">{{
                            $t('register')
                            }}</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import config from "../../http/config";
export default {
    model: {
        prop: 'inputValue',
        event: 'input'
    },
    props: {
        /**
         * 当前输入的值
         */
        inputValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            config,
            checked: true,
            username: '',
            code: '',
            password: this.inputValue,
            passwordType: 'password',
        };
    },
    methods: {
        switchPasswordType() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
        },
        back() {
            return window.history.back();
        },
        doRegister() {
            if (this.username === "" || this.username === null || this.username === undefined) {
                this.$toast(this.$t('userNamePlaceholder'));
                return false;
            }
            if (this.password === "" || this.password === null || this.password === undefined) {
                this.$toast(this.$t('passwordPlaceholder'));
                return false;
            }
            if (this.code === "" || this.code === null || this.code === undefined) {
                this.$toast(this.$t('inviteCodeePlaceholder'));
                return false;
            }
            // if (!this.checked) {
            //     this.$toast(this.$t('checkAgreement'));
            //     return false;
            // }
            this.$http({
                method: 'get',
                data: {
                    username: this.username,
                    password: this.password,
                    code: this.code
                },
                url: 'member_register'
            }).then(res => {
                if (res.code === 200) {
                    this.$toast(res.msg);
                    localStorage.setItem('token', res.data)
                    this.$router.push("Home")
                } else {
                    this.$toast(res.msg);
                }
            })
        },
        switchLanguage() {
            this.$router.push({ path: '/SwitchLanguage', query: { fromPage: 'login' } });
        },
    },
    created() {
        if (localStorage.getItem('token')) {
            return window.history.back();
        }
    }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.nav-bar {
    background: transparent;
}

.register {
    height: 100vh;
    background: aliceblue;
}

.bg-container .bg-wrapper .register .nav-bar {
    background: 0 0;
}

.register .wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 80px;
}

.logo-container {
    margin: 0 auto;
    width: 45%;
}

.logo-container .logo-wrapper {
    position: relative;
    padding-bottom: 62.5%;
}

.logo-container .logo-wrapper .logo-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
}

.register .wrapper .title {
    line-height: 100px;
    text-align: center;
    font-size: 34px;
    font-weight: 700;
    color: #1989fa;
    letter-spacing: 5px;
}

.register .wrapper .loginForm {
    padding: 60px;
}

.register .wrapper .loginForm .input {
    padding: 0 20px;
    margin-top: 35px;
    // border-radius: 50px;
    text-align: center;
    line-height: 80px;
    font-size: 30px;
    color: #4e4e4e;
    background: rgba(255, 255, 255, 0.5);
}

::v-deep .register .wrapper .loginForm .van-field__control::-webkit-input-placeholder {
    color: #000;
}

::v-deep .register .wrapper .loginForm .van-field__control::-moz-placeholder {
    color: #000;
}

::v-deep .register .wrapper .loginForm .van-field__control:-ms-input-placeholder {
    color: #000;
}

::v-deep .register .wrapper .loginForm .van-field__control::-ms-input-placeholder {
    color: #000;
}

::v-deep .register .wrapper .loginForm .van-field__control::placeholder {
    color: #000;
}

::v-deep .van-field__right-icon .van-icon {
    font-size: 50px;
}

::v-deep .van-icon {
    font-size: 50px;
}

.register .wrapper .loginForm .reset-text {
    margin: 30px 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.register .wrapper .loginForm .reset-text span {
    color: #fff;
    font-size: 25px;
    font-weight: 500;
    line-height: 15px;
}

.register .wrapper .loginForm .register-text {
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.register .wrapper .loginForm .register-text span {
    color: #fff;
    font-size: 25px;
    font-weight: 500;
    line-height: 20px;
}

.register .wrapper .loginForm .login-btn {
    margin-top: 60px;
    width: 100%;
    height: 80px;
    // border-radius: 50px;
    color: #fff;
    background: #1989fa;
    font-size: 30px;
    font-weight: bolder;
    border: none;
}

.register .wrapper .loginForm .agreement {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.register .wrapper .loginForm .agreement .agreement-text {
    margin-left: 10px;
    font-size: 25px;
    color: #fff;
    font-weight: 500;
    line-height: 30px;
}

::v-deep .agreement .van-icon {
    font-size: 30px;
}

::v-deep .agreement .van-checkbox__icon {
    font-size: 38px;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
    color: #fff;
    border-color: rgb(126, 86, 120);
    background-color: rgb(126, 86, 120);
}
</style>
